import React from 'react';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import i18n from 'i18n';

export const StyledWithoutContentWrapper = styled.div`
  position: absolute;
  top: ${scaleSize(407)}px;
  display: inline-block;
  box-sizing: border-box;
  width: ${scaleSize(840)}px;
  height: ${scaleSize(100)}px;
  margin-left: ${scaleSize(20)}px;
  text-align: center;
  white-space: normal;
`;

export const StyledWithoutContentText = styled.div`
  font-size: ${scaleSize(40)}px;
  line-height: 1.2;
  text-align: center;
  color: ${({ theme }) => theme.defaultColor};
`;

const NotLoggedStub = () => {
  return (
    <StyledWithoutContentWrapper>
      <StyledWithoutContentText>{i18n.t('epg.playerStubText')}</StyledWithoutContentText>
    </StyledWithoutContentWrapper>
  );
};

export default NotLoggedStub;
